import { render, staticRenderFns } from "./NewPostEditor.vue?vue&type=template&id=225da5b5"
import script from "./NewPostEditor.vue?vue&type=script&lang=js"
export * from "./NewPostEditor.vue?vue&type=script&lang=js"
import style0 from "./NewPostEditor.vue?vue&type=style&index=0&id=225da5b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports